











































import { Component } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import Vue from "vue";
import { appTitle, appLocation } from "../../../constants";

@Component({})
export default class Login extends Vue {
  username = "";
  password = "";
  valid = false;
  loading = false;

  @State("auth") authState: any;
  @Action("login") loginAction: any;
  get errorMessage() {
    return this.$t(this.$store.state.auth.error.i18n);
  }

  get title() {
    return appTitle + " - " + appLocation;
  }

  login() {
    (this.$refs.form as any).validate();
    if (this.valid) {
      this.loading = true;
      this.loginAction({
        user: {
          email: this.username,
          password: this.password
        }
      });
    }
  }
}
